import type { MessageDescriptor } from 'react-intl';

import { canScopeShowResetDate } from '../../common/credits-backend/scope';
import type { CreditDenialScope } from '../../common/credits-backend/types';
import { messages } from './messages';

export const normalizeAgentName = (agentName?: string): string | undefined =>
	agentName?.trim() || undefined;

type DepletedDescriptorOptions = {
	scope?: CreditDenialScope;
	agentName?: string;
	hasContext: boolean;
	hasResetDate: boolean;
};

/**
 * Picks the depleted message for a denial scope. `AGENT` copy needs a name, so a blank one uses
 * the non-agent copy. The name is normalized again here so a raw name from any caller still
 * selects the right copy.
 */
export const getDepletedDescriptor = ({
	scope,
	agentName,
	hasContext,
	hasResetDate,
}: DepletedDescriptorOptions): MessageDescriptor => {
	const showsResetDate = hasResetDate && canScopeShowResetDate(scope);
	if (scope === 'AGENT' && normalizeAgentName(agentName)) {
		if (hasContext) {
			return showsResetDate
				? messages.agentDepletedWithContextAndResetDate
				: messages.agentDepletedWithContext;
		}
		return showsResetDate
			? messages.agentDepletedWithResetDate
			: messages.agentDepletedWithoutResetDate;
	}
	if (hasContext) {
		return showsResetDate ? messages.depletedWithContextAndResetDate : messages.depletedWithContext;
	}
	return showsResetDate ? messages.depletedWithResetDate : messages.depletedWithoutResetDate;
};
